/* Read aloud with the reader's own browser voices (Web Speech API).
   The control stays hidden where the API is missing. */
(function () {
    'use strict';

    var button = document.querySelector('[data-listen]');
    var row = document.querySelector('[data-listen-row]');
    var content = document.querySelector('[data-content]');
    if (!button || !content || !('speechSynthesis' in window)) {
        return;
    }

    var synth = window.speechSynthesis;
    var playing = false;
    var labelPlay = button.getAttribute('data-label-play');
    var labelStop = button.getAttribute('data-label-stop');

    if (row) {
        row.hidden = false;
    }

    function setState(isPlaying) {
        playing = isPlaying;
        button.setAttribute('aria-pressed', String(isPlaying));
        button.textContent = isPlaying ? labelStop : labelPlay;
    }

    function readableText() {
        var clone = content.cloneNode(true);
        clone.querySelectorAll('pre, script, style, figure, .kg-embed-card, .kg-signup-card').forEach(function (el) {
            el.remove();
        });
        return clone.textContent.replace(/\s+/g, ' ').trim();
    }

    // Prefer a natural-sounding voice in the page language, if the system has one
    function pickVoice(lang) {
        var voices = synth.getVoices();
        var base = lang.slice(0, 2).toLowerCase();
        var matching = voices.filter(function (voice) {
            return voice.lang.toLowerCase().indexOf(base) === 0;
        });
        var preferred = matching.filter(function (voice) {
            return /natural|enhanced|premium|neural/i.test(voice.name);
        });
        return preferred[0] || matching[0] || null;
    }

    button.addEventListener('click', function () {
        if (playing) {
            synth.cancel();
            setState(false);
            return;
        }

        var text = readableText();
        if (!text) {
            return;
        }

        var lang = document.documentElement.lang || 'en';
        var utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = lang;
        var voice = pickVoice(lang);
        if (voice) {
            utterance.voice = voice;
        }
        utterance.onend = function () {
            setState(false);
        };
        utterance.onerror = function () {
            setState(false);
        };

        synth.cancel();
        synth.speak(utterance);
        setState(true);
    });

    window.addEventListener('pagehide', function () {
        synth.cancel();
    });
})();
